import { ResponseData, TUserInfo } from "@/typings";
import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";

export async function fetchUserInfo(params?: any) {
  return await fetchYooFindsApi<ResponseData<TUserInfo>>(
    getUri("api/user/info", params || {})
  );
}
